import { ClerkProvider } from '@clerk/clerk-react';
import React from 'react';

export const withClerkProvider = (Component: React.ComponentType) => {
  return (props: any) => {
    return (
      <ClerkProvider
        signInUrl="/sign-in"
        publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY ?? ''}
      >
        <Component {...props} />
      </ClerkProvider>
    );
  };
};
